import React, { memo, useEffect, useState, useRef, useCallback } from 'react';
import styles from './TurnControl.module.less';
import Lottie from 'lottie-web';
import { debounce, reject } from 'lodash-es';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import turnAnimate from '../../../utils/turnAnimate.json';
import { PCStoreJsBridge } from '../../../nativeapi';
import config from '../config';

import { getVipState, openGroup, setShowList } from '../../../actions/wallpaperPay';
import { updateShowWpTurnLimit } from '../../../actions/wallpaper';
import { updateShowWpOrder } from '../../../actions/wallpaper';

import { logging, logPostInfo } from '../../../actions/log';
import useLoginStatus from '../../../utils/hooks/useLoginStatus';
import { handleLogin } from '../../../utils/hooks/useLoginStatus';
import controlOpen from '../../../static/wp/wp_control_open.png';
import controlAdd from '../../../static/wp/wp_control_add.svg';
import Toast from '../../../components/Toast/Toast';

const timeList = [
  // { text: '24小时', time: 1440 },
  { text: '12小时', time: 720 },
  // { text: '6小时', time: 300 },
  { text: '1小时', time: 60 },
  { text: '30分钟', time: 30 },
  // { text: '15分钟', time: 15 },
  // { text: '10分钟', time: 10 },
  { text: '5分钟', time: 5 },
];

const SelectVipState = createSelector(
  state => state.wallpaperPay,
  wallpaperPay => wallpaperPay.vipState,
);

const SelectTurnList = createSelector(
  state => state.wallpaperPay,
  wallpaperPay => wallpaperPay.mineTurnInfo,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);

const selectListShow = createSelector(
  state => state.wallpaperPay,
  wallpaperPay => wallpaperPay.loopTimeShow,
);

let CONTROL_OPEN = 0;
let LOGIN_CONTROL = 0;
export default memo(() => {
  const dispatch = useDispatch();
  const [node, setNode] = useState(null);
  const lottieInstaceRef = useRef(null);
  const [frequencyTime, setFrequencyTime] = useState(timeList[timeList.length - 1]);
  // const [showList, setShowList] = useState(false);
  const showList = useSelector(selectListShow);
  const [openTurn, setOpenTurn] = useState(false);
  const vipState = useSelector(SelectVipState);
  const turnList = useSelector(SelectTurnList);
  const logInfoData = useSelector(selectLogInfo);
  const userInfo = useSelector(selectUserInfo);
  const loginStatus = useLoginStatus();

  const initAnimation = () => {
    const lottieInstace = Lottie.loadAnimation({
      container: node, // the dom element that will contain the animation
      renderer: 'svg',
      // loop: true,
      autoplay: false,
      autoloadSegments: false,
      animationData: turnAnimate,
      name: 'turnControl',
    });
    lottieInstaceRef.current = lottieInstace;
  };

  useEffect(() => {
    if (node) {
      initAnimation();
    }
  }, [node]);

  useEffect(() => {
    if (!lottieInstaceRef?.current) {
      return;
    }
    if (openTurn) {
      lottieInstaceRef.current.goToAndStop(25, true);
    } else {
      lottieInstaceRef.current.goToAndStop(1, true);
    }
  }, [openTurn, lottieInstaceRef, node]);

  useEffect(() => {
    updateTurn();
    window.PCStore_WpMine_TurnUpdate = () => {
      updateTurn();
    };
  }, []);

  useEffect(() => {
    if (LOGIN_CONTROL === 1) {
      PCStoreJsBridge.switchWpOpenTurn({
        switch: 'on',
        duration: frequencyTime.time,
      }).then(res => {
        if (res) {
          updateTurn();
          LOGIN_CONTROL = 0;
        }
      });
    }
  }, [loginStatus]);

  const updateTurn = useCallback(() => {
    if (window.external && window.external.get_wallpaper_carousel_switch_info) {
      let switchData = JSON.parse(window.external.get_wallpaper_carousel_switch_info()) || {};
      setOpenTurn(switchData.switch === 'on' ? true : false);
      setFrequencyTime(timeList.find(el => el.time === ~~switchData.duration));
    }
  }, [loginStatus]);
  const backLimite = parmas => {
    if (parmas === 2) {
      PCStoreJsBridge.switchWpOpenTurn({
        switch: 'on',
        duration: frequencyTime.time,
      }).then(res => {
        if (res) {
          setOpenTurn(true);
          lottieInstaceRef.current.goToAndStop(25, true);
          dispatch(
            logging({
              category: 'Wallpaper',
              action: 'R_Wallpaper_Loop_Start',
              label: '',
              param2: {
                source: `Wallpaper_Mine||loop`,
                source_p: logInfoData.source_p,
                source_pp: logInfoData.source_pp,
                Looptype: 3,
              },
            }),
          );
        }
      });
    }
  };

  const backOrder = parmas => {
    if (parmas === true) {
      PCStoreJsBridge.switchWpOpenTurn({
        switch: 'on',
        duration: frequencyTime.time,
      }).then(res => {
        if (res) {
          setOpenTurn(true);
          lottieInstaceRef.current.goToAndStop(25, true);
          dispatch(
            logging({
              category: 'Wallpaper',
              action: 'R_Wallpaper_Loop_Start',
              label: '',
              param2: {
                source: `Wallpaper_Mine||loop`,
                source_p: logInfoData.source_p,
                source_pp: logInfoData.source_pp,
                Looptype: 3,
              },
            }),
          );
        }
      });
    }
  };

  const setTime = () => {
    setTimeout(() => {
      CONTROL_OPEN = 0;
    }, 2000);
  };

  const handleControlOpen = useCallback(async () => {
    if (CONTROL_OPEN === 0) {
      if (turnList?.invalidCarouselList?.length > 0 && !openTurn) {
        dispatch(
          updateShowWpTurnLimit({
            show: true,
            callbackTurnLimit: backLimite,
            callbackTurnOrder: backOrder,
          }),
        );
      } else {
        if (!loginStatus && !openTurn) {
          handleLogin();
          LOGIN_CONTROL = 1;
        } else {
          PCStoreJsBridge.switchWpOpenTurn({
            switch: !openTurn ? 'on' : 'off',
            duration: frequencyTime.time,
          }).then(res => {
            if (res) {
              setOpenTurn(!openTurn);
              lottieInstaceRef.current.goToAndStop(!openTurn ? 25 : 0, true);
              CONTROL_OPEN = 1;
              setTime();
              if (!openTurn) {
                dispatch(
                  logging({
                    category: 'Wallpaper',
                    action: 'R_Wallpaper_Loop_Start',
                    label: '',
                    param2: {
                      source: `Wallpaper_Mine||loop`,
                      source_p: logInfoData.source_p,
                      source_pp: logInfoData.source_pp,
                      Looptype: 3,
                    },
                  }),
                );
              } else {
                dispatch(
                  logging({
                    category: 'Wallpaper',
                    action: 'R_Wallpaper_Loop_Stop',
                    label: '',
                    param2: {
                      source: `Wallpaper_Mine||loop`,
                      source_p: logInfoData.source_p,
                      source_pp: logInfoData.source_pp,
                      Looptype: 3,
                    },
                  }),
                );
              }
            }
          });
        }
      }
    } else {
      Toast.error({
        content: '操作太过频繁，请稍后再试',
      });
    }
  }, [openTurn, turnList, loginStatus]);

  const handleSetTime = useCallback(
    info => {
      // if (openTurn) {
      PCStoreJsBridge.switchWpOpenTurn({
        switch: openTurn ? 'on' : 'off',
        duration: info.time,
      }).then(res => {
        if (res) {
          setFrequencyTime(info);
        }
      });
      dispatch(setShowList(false));
    },
    [openTurn, showList],
  );

  const handleShowList = () => {
    dispatch(setShowList(!showList));
  };

  const callbackOpen = () => {
    dispatch(openGroup(true));
  };

  const openList = useCallback(async () => {
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'C_Wallpaper_Loop_Mine',
        label: '',
        param2: {
          source: `Wallpaper_Mine||loop`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    if (!loginStatus) {
      handleLogin();
    } else {
      if (!vipState.vipState) {
        dispatch(
          updateShowWpOrder({
            show: true,
            wallpaperId: '',
            code: '',
            wpType: 3, // 1: 单张壁纸，2：壁纸包 3: 仅仅订阅
            callbackTurnOrder: callbackOpen,
            scenetype: 'resident_category', // 'set', 'dl', 'resident','resident_category', 'loop_single', 'loop_batch', 'loop_start'
          }),
          getVipState(),
        );
      } else {
        dispatch(openGroup(true));
      }
    }
  }, [vipState, loginStatus]);

  return (
    <div className={styles.turn_control}>
      <div className="control_left">
        <div className="turn_open_btn">
          壁纸轮播开关
          <div ref={r => setNode(r)} className="open_btn" onClick={handleControlOpen} />
        </div>
        <div className="control_left line" />
        <div className="frequency" onClick={handleShowList}>
          壁纸轮播频率
          <div className="frequency_btn">
            {frequencyTime.text}
            <img src={controlOpen} className={` ${showList ? 'btn_active' : ''}`} />
          </div>
          {showList && (
            <div className="frequency_list">
              {timeList.map((el, index) => (
                <div
                  className={`frequency_item ${
                    el.text === frequencyTime.text ? `frequency_item_active` : ''
                  }`}
                  key={index}
                  onClick={() => handleSetTime(el)}
                >
                  {el.text}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className="control_right">
        <div className="control_btn" onClick={openList}>
          <img src={controlAdd} />
          <span className="control_text">添加壁纸</span>
        </div>
      </div>
    </div>
  );
});
